module.exports = "<div class=\"home-modal\">\n  <div class=\"modal-head\">\n    <div class=\"close-btn\" v-on:click=\"$parent.$emit('close')\"></div>\n  </div>\n  <div class=\"modal-body\"><iframe v-bind:src=\"url\" frameborder=\"0\" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe></div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./static-content/public/javascripts/components/video.html
// module id = 414
// module chunks = 0